<template>
  <div :class="$b()">
    <slot name="result-icon" />
    <h2 :class="$b('header')">
      {{ title }}
    </h2>
    <p :class="$b('content')">
      {{ content }}
    </p>
    <dp-button size="lg" :class="$b('button')" @click="$emit('click')">
      {{ actionLabel }}
    </dp-button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { DpButton } from '@dp-ui-kit/vue';

export default defineComponent({
  name: 'FormWidgetResult',

  components: {
    DpButton,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    content: {
      type: String,
      required: true,
    },

    actionLabel: {
      type: String,
      required: true,
    },
  },

  emits: ['click'],
});
</script>
<style scoped lang="scss">
@use 'src/assets/scss/variables' as v;

.dp-form-widget-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: v.$spacer-xl;
  margin-left: v.$spacer-lg;
  margin-right: v.$spacer-lg;

  &__header {
    font-size: v.$h2-font-size;
    font-weight: v.$font-weight-semibold;
    margin-top: v.$spacer-lg;
  }

  &__content {
    font-size: v.$font-size-lg;
    color: v.$gray-600;
    margin-top: v.$spacer-md;
  }

  &__button {
    margin-top: v.$spacer-lg;
  }
}
</style>
